export enum Field {
  RealName = 'realName',
  Login = 'login',
  Email = 'email',
  Password = 'password',
  SubscribeToNewsletter = 'subscribeToNewsletter',
  AgreeRules = 'agreeRules',
  ZipCode = 'zipCode',
}
